import { render, staticRenderFns } from "./LOOKGOONG.vue?vue&type=template&id=1f37c319&"
import script from "./LOOKGOONG.vue?vue&type=script&lang=js&"
export * from "./LOOKGOONG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports